// path: src/Recap.js
import React from "react";
import "./App.css";

const Recap = ({
    outcome = "loss", // "win" | "loss"
    levelsCompleted = 0,
    levelReached = 1,
    correctClicks = 0,
    newlyUnlocked = 0,
    totalUnlocked = 0,
    totalCards = 100,
    onPlayAgain,
    onMainMenu,
    }) => {
    return (
        <div className="recapScreen">
            <div className="recapCard">
                <h1 className="impactFont recapTitle">
                    {outcome === "win" ? "You Won!" : "Run Ended"}
                </h1>

            <div className="recapSubTitle">
                {outcome === "win"
                ? "Final level cleared."
                : `You reached Level ${levelReached}.`}
            </div>

            <div className="recapStats">
            <div className="recapStat">
                <div className="recapStatLabel">Levels Completed</div>
                <div className="recapStatValue">{levelsCompleted}</div>
            </div>

            <div className="recapStat">
                <div className="recapStatLabel">Highest Level Reached</div>
                <div className="recapStatValue">{levelReached}</div>
            </div>

            <div className="recapStat">
                <div className="recapStatLabel">Correct Clicks</div>
                <div className="recapStatValue">{correctClicks}</div>
            </div>

            <div className="recapStat">
                <div className="recapStatLabel">Cards Unlocked (This Run)</div>
                <div className="recapStatValue">+{newlyUnlocked}</div>
            </div>

            <div className="recapStat">
                <div className="recapStatLabel">Collection</div>
                <div className="recapStatValue">
                    {totalUnlocked}/{totalCards}
                </div>
            </div>
            </div>

            <div className="recapButtons">
            <button className="homePrimaryButton" onClick={onPlayAgain}>
                Play Again
            </button>

            <button className="homePrimaryButton" onClick={onMainMenu}>
                Main Menu
            </button>
            </div>

            <div className="recapHint">
                {outcome === "win"
                ? "Nice! Your collection progress was saved."
                : "Try again — your collection progress was saved."}
            </div>
        </div>
        </div>
    );
    };

export default Recap;
